module.exports = __webpack_public_path__ + "img/getboarded.2caab84f.svg";